import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import api from '../Utils/Axios';
import Seo from '../Components/Seo';


const Registration = () => {

  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    consentPrivacy: false,
  })

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")



  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      const digitsOnly = value.replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, phone: digitsOnly }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))

  }

  const handleRegister = async (e) => {
    e.preventDefault()
    setSuccess("")
    setError("")



    const fullName = `${formData.firstname} ${formData.lastname}`.trim();
    if (!formData.firstname || !formData.lastname || !formData.email || !formData.password || !formData.confirmPassword) {
      setError("please fill all fields ya shaikh.")
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("password and confirmPassword dosent match.")
      return;
    }

    if (!formData.consentPrivacy) {
      setError('Please accept the privacy policy before creating an account.');
      return;
    }

    try {
      setLoading(true)

      const payload = {
        name: fullName,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
      };

      const response = await api.post('/api/auth/register', payload)
      if (response.status === 200 || response.status === 201) {
        if (response.data?.token) localStorage.setItem("token", response.data.token);
        if (response.data?.user) localStorage.setItem("user", JSON.stringify(response.data.user));
        setSuccess('Account created successfully')
        alert(response.data?.message || "Account created successfully");
        navigate('/login')
      } else {
        const msg = 'Failed to create account';
        setError(msg)
        alert(msg);
      }
    } catch (error) {
      const msg = error?.response?.data?.message || 'Failed to create account';
      setError(msg)
      alert(msg);
    } finally {
      setLoading(false)
    }
  }












  return (
    <div>
      <Seo title="Register | QTECH" description="Create a QTECH account." path="/register" noindex />
      <div className="ltn__login-area pb-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area text-center">
                <h1 className="section-title">
                  Register <br />
                  Your Account
                </h1>
                <p>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. <br />
                  Sit aliquid, Non distinctio vel iste.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="account-login-inner">
                <form onSubmit={handleRegister} className="ltn__form-box contact-form-box">
                  <input type="text" name="firstname" placeholder="First Name"  value={formData.firstname} onChange={handleChange}/>
                  <input type="text" name="lastname" placeholder="Last Name"  value={formData.lastname} onChange={handleChange}/>
                  <input type="text" name="email" placeholder="Email*"  value={formData.email} onChange={handleChange}/>
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                  <input type="password" name="password" placeholder="Password*"  value={formData.password} onChange={handleChange}/>
                  <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm Password*"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  <label className="checkbox-inline">
                    <input type="checkbox" name="consentPrivacy" checked={formData.consentPrivacy} onChange={handleChange}/>I consent to Herboil
                    processing my personal data in order to send personalized
                    marketing material in accordance with the consent form and the
                    privacy policy.
                  </label>
                  <label className="checkbox-inline">
                    <input type="checkbox" name="consentPrivacy" checked={formData.consentPrivacy} onChange={handleChange}/>
                    By clicking "create account", I consent to the privacy policy.
                  </label>
                  {error ? <p style={{ color: "#dc3545", marginBottom: "10px" }}>{error}</p> : null}
                  {success ? <p style={{ color: "#28a745", marginBottom: "10px" }}>{success}</p> : null}
                  <div className="btn-wrapper">
                    <button
                      disabled={loading}
                      className={`theme-btn-1 btn reverse-color btn-block ${loading ? 'disabled' : ''}`}
                      type="submit"
                    >
                      {loading ? 'Creating Account...' : 'CREATE ACCOUNT'}
                    </button>
                  </div>
                </form>
                <div className="by-agree text-center">
                  <p>By creating an account, you agree to our:</p>
                  <p>
                    <Link to="/terms-of-conditions">
                      TERMS OF CONDITIONS &nbsp; &nbsp; | &nbsp; &nbsp; PRIVACY POLICY
                    </Link>
                  </p>
                  <div className="go-to-btn mt-50">
                    <Link to="/login">ALREADY HAVE AN ACCOUNT ?</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Registration
